import * as types from './types';
import { HttpClient, JSON_STRING } from '../../../../services/http/http-client';
import { SETTINGS_URL } from '../../../../services/common-urls';

export const billingSettingsActions = {
  async [types.BillingSettingsData.FETCH.ALL] ({commit, getters}, payload) {
    const billingData = await HttpClient.post(SETTINGS_URL, {
      section: 'billing',
      output: JSON_STRING,
    });
    commit(types.BillingSettingsData.SET.ALL, {
      ...billingData.data
    });
    console.log(getters.billingSettingsData)
  }
}
